import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, SparklesIcon } from 'lucide-react';
export function KitContentsSection() {
  const ebookIncludes = ['Fundamentos de la inteligencia artificial (sin tecnicismos)', 'Cómo crear productos digitales desde cero (ebooks, contenido, servicios)', 'Modelos de negocio con IA de bajo costo', 'Cómo generar contenido viral para redes sociales', 'Creación de ebooks profesionales en pocos días', 'Estrategias para vender sin invertir en publicidad', 'Cómo automatizar ingresos y procesos con IA', 'Herramientas clave: ChatGPT, Canva, CapCut, ElevenLabs', 'Cómo crear un canal de YouTube sin mostrar tu rostro', 'Mentalidad y enfoque para generar ingresos online'];
  const floatingAnimation = {
    y: [0, -8, 0],
    transition: {
      duration: 3,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  };
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#0d0b14]" data-id="element-99">
      <div className="max-w-7xl mx-auto" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-101">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-102">
            Te explico todo lo que incluye el kit + bonus de regalos exclusivos
          </h2>
          <div className="w-24 h-1 bg-gradient-primary mx-auto rounded-full" data-id="element-103"></div>
        </motion.div>

        {/* Main Product */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-pink-500/10 to-purple-500/10 rounded-3xl p-8 sm:p-12 shadow-xl mb-12 border border-pink-500/20 backdrop-blur-sm" data-id="element-104">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-105">
            <div className="order-2 lg:order-1" data-id="element-106">
              <div className="inline-block px-4 py-1.5 rounded-full bg-pink-500/30 text-pink-200 font-bold text-sm mb-4" data-id="element-107">
                PRODUCTO BEST SELLER
              </div>
              <h3 className="text-3xl font-bold text-white mb-2" data-id="element-108">
                APRENDE A GENERAR INGRESOS CON LA IA
              </h3>
              <h4 className="text-2xl font-semibold text-pink-400 mb-6" data-id="element-109">
                "Vuelve a Brillar con IA"
              </h4>

              <p className="text-slate-300 mb-8 text-lg" data-id="element-110">
                Convierte tu celular en una fuente de ingresos. Domina la
                inteligencia artificial y crea un negocio digital sin invertir
                grandes cantidades de dinero.
              </p>

              <div className="space-y-3" data-id="element-111">
                <p className="font-semibold text-slate-300 mb-4" data-id="element-112">Incluye:</p>
                {ebookIncludes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-113">
                    <CheckCircle2 className="w-6 h-6 text-pink-400 flex-shrink-0" data-id="element-114" />
                    <span className="text-slate-300" data-id="element-115">{item}</span>
                  </div>)}
              </div>
            </div>
            <div className="order-1 lg:order-2 flex justify-center relative" data-id="element-116">
              <div className="absolute inset-0 bg-pink-500/20 blur-3xl rounded-full opacity-50 -z-10" data-id="element-117"></div>
              <img src="https://cdn.magicpatterns.com/uploads/cZN5msnqKAUtnBoigpaUb8/task_01kkt7tcn7f40b2e1bnzbyftkc_1773628381_img_1_-_Editado.png" alt="Ebook Vuelve a Brillar con IA" className="w-full max-w-md drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-118" />
            </div>
          </div>
        </motion.div>

        {/* Bonus Section Intro */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12 mt-8" data-id="element-119">
          <motion.div animate={{
          textShadow: ['0 0 20px rgba(236,72,153,0.4), 0 0 40px rgba(168,85,247,0.2)', '0 0 30px rgba(236,72,153,0.6), 0 0 60px rgba(168,85,247,0.4)', '0 0 20px rgba(236,72,153,0.4), 0 0 40px rgba(168,85,247,0.2)']
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="inline-flex items-center gap-3 text-3xl sm:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 via-purple-400 to-pink-400 mb-4" data-id="element-120">
            <SparklesIcon className="w-8 h-8 sm:w-10 sm:h-10 text-pink-400" data-id="element-121" />
            BONUS EXCLUSIVOS
            <SparklesIcon className="w-8 h-8 sm:w-10 sm:h-10 text-purple-400" data-id="element-122" />
          </motion.div>
          <p className="text-lg sm:text-xl text-slate-400 mt-3" data-id="element-123">
            Estos regalos son{' '}
            <span className="text-pink-400 font-semibold" data-id="element-124">tuyos</span> al
            comprar hoy
          </p>
        </motion.div>

        {/* Bonuses Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-125">
          {/* Bonus 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="relative rounded-3xl p-[1px] overflow-hidden group" data-id="element-126">
            {/* Animated glowing border */}
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-purple-500 via-pink-500 to-purple-500 opacity-40 group-hover:opacity-70 transition-opacity duration-500 animate-border-glow" data-id="element-127"></div>

            <div className="relative bg-gradient-to-br from-purple-950/80 via-[#0d0b14] to-[#0d0b14] backdrop-blur-sm rounded-3xl p-8 sm:p-10 flex flex-col h-full overflow-hidden" data-id="element-128">
              {/* Badge */}
              <motion.div animate={{
              scale: [1, 1.05, 1]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="absolute top-4 right-4 flex items-center gap-1.5 bg-gradient-to-r from-purple-600 to-purple-400 text-white text-sm font-bold px-5 py-2 rounded-full shadow-lg shadow-purple-500/30 z-10" data-id="element-129">
                <SparklesIcon className="w-4 h-4" data-id="element-130" />
                🎁 REGALO
              </motion.div>

              {/* Image with floating animation */}
              <div className="relative flex justify-center mb-8 mt-8" data-id="element-131">
                <div className="absolute inset-0 bg-purple-500/30 blur-[60px] rounded-full opacity-70 -z-10" data-id="element-132"></div>
                <div className="absolute inset-0 bg-purple-400/15 blur-[100px] rounded-full scale-150 -z-10" data-id="element-133"></div>
                <motion.img animate={floatingAnimation} src="https://cdn.magicpatterns.com/uploads/thV81ztV1CYJJt29bB5DL3/task_01kkt73ynafbb8wwt8yseb9emj_1773627683_img_0_-_Editado.png" alt="Diario de Gratitud" className="h-64 sm:h-72 object-contain drop-shadow-[0_20px_40px_rgba(168,85,247,0.4)]" data-id="element-134" />
              </div>

              <div className="inline-block px-4 py-1.5 rounded-full bg-purple-500/20 text-purple-300 font-bold mb-4 w-max text-lg" data-id="element-135">
                BONUS 1
              </div>
              <h4 className="text-xl sm:text-2xl font-bold text-white mb-3" data-id="element-136">
                Diario de Gratitud y Manifestación
              </h4>
              <div className="flex-grow" data-id="element-137">
                <p className="text-slate-400 leading-relaxed" data-id="element-138">
                  Una guía de 30 días para transformar tu vida a través de la
                  gratitud. Aprende a reconectar contigo, elevar tu energía y
                  crear una rutina que te ayude a sentir más paz, claridad y
                  bienestar emocional. Incluye: Ejercicios diarios de gratitud,
                  espacios de escritura y reflexión, prácticas de amor propio,
                  herramientas para cambiar tu mentalidad.
                </p>
              </div>

              {/* Value emphasis */}
              <div className="mt-6 pt-4 border-t border-white/10 flex items-center justify-between" data-id="element-139">
                <span className="text-slate-500 line-through text-lg" data-id="element-140">
                  Valor: US$19
                </span>
                <span className="text-emerald-400 font-extrabold text-xl tracking-wide" data-id="element-141">
                  ¡GRATIS!
                </span>
              </div>
            </div>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="relative rounded-3xl p-[1px] overflow-hidden group" data-id="element-142">
            {/* Animated glowing border */}
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-blue-500 via-cyan-400 to-blue-500 opacity-40 group-hover:opacity-70 transition-opacity duration-500 animate-border-glow" data-id="element-143"></div>

            <div className="relative bg-gradient-to-br from-blue-950/80 via-[#0d0b14] to-[#0d0b14] backdrop-blur-sm rounded-3xl p-8 sm:p-10 flex flex-col h-full overflow-hidden" data-id="element-144">
              {/* Badge */}
              <motion.div animate={{
              scale: [1, 1.05, 1]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: 0.3
            }} className="absolute top-4 right-4 flex items-center gap-1.5 bg-gradient-to-r from-blue-600 to-cyan-400 text-white text-sm font-bold px-5 py-2 rounded-full shadow-lg shadow-blue-500/30 z-10" data-id="element-145">
                <SparklesIcon className="w-4 h-4" data-id="element-146" />
                🎁 REGALO
              </motion.div>

              {/* Image with floating animation */}
              <div className="relative flex justify-center mb-8 mt-8" data-id="element-147">
                <div className="absolute inset-0 bg-blue-500/30 blur-[60px] rounded-full opacity-70 -z-10" data-id="element-148"></div>
                <div className="absolute inset-0 bg-cyan-400/15 blur-[100px] rounded-full scale-150 -z-10" data-id="element-149"></div>
                <motion.img animate={floatingAnimation} src="https://cdn.magicpatterns.com/uploads/tHTCiPMad4LuZFsFZ2HMca/task_01kkjajhx2f8hb56yrr53ge4ce_1773362848_img_0_-_Editado.png" alt="Guía de IA" className="h-64 sm:h-72 object-contain drop-shadow-[0_20px_40px_rgba(59,130,246,0.4)]" data-id="element-150" />
              </div>

              <div className="inline-block px-4 py-1.5 rounded-full bg-blue-500/20 text-blue-300 font-bold mb-4 w-max text-lg" data-id="element-151">
                BONUS 2
              </div>
              <h4 className="text-xl sm:text-2xl font-bold text-white mb-3" data-id="element-152">
                Guía de herramientas de Inteligencia Artificial
              </h4>
              <div className="flex-grow" data-id="element-153">
                <p className="text-slate-400 leading-relaxed" data-id="element-154">
                  Una guía completa para conocer que inteligencia artificial
                  usar para cada cosa que quieras desarrollar para generar
                  dinero. Descubre cómo crear contenido, productos digitales y
                  automatizar procesos usando las herramientas más poderosas del
                  mercado actual, sin necesidad de experiencia previa.
                </p>
              </div>

              {/* Value emphasis */}
              <div className="mt-6 pt-4 border-t border-white/10 flex items-center justify-between" data-id="element-155">
                <span className="text-slate-500 line-through text-lg" data-id="element-156">
                  Valor: US$27
                </span>
                <span className="text-emerald-400 font-extrabold text-xl tracking-wide" data-id="element-157">
                  ¡GRATIS!
                </span>
              </div>
            </div>
          </motion.div>

          {/* Bonus 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="relative rounded-3xl p-[1px] overflow-hidden group" data-id="element-158">
            {/* Animated glowing border */}
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-pink-500 via-rose-400 to-pink-500 opacity-40 group-hover:opacity-70 transition-opacity duration-500 animate-border-glow" data-id="element-159"></div>

            <div className="relative bg-gradient-to-br from-pink-950/80 via-[#0d0b14] to-[#0d0b14] backdrop-blur-sm rounded-3xl p-8 sm:p-10 flex flex-col h-full overflow-hidden" data-id="element-160">
              {/* Badge */}
              <motion.div animate={{
              scale: [1, 1.05, 1]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: 0.6
            }} className="absolute top-4 right-4 flex items-center gap-1.5 bg-gradient-to-r from-pink-600 to-rose-400 text-white text-sm font-bold px-5 py-2 rounded-full shadow-lg shadow-pink-500/30 z-10" data-id="element-161">
                <SparklesIcon className="w-4 h-4" data-id="element-162" />
                🎁 REGALO
              </motion.div>

              {/* Styled Cover with floating animation */}
              <div className="relative flex justify-center mb-8 mt-8" data-id="element-163">
                <div className="absolute inset-0 bg-pink-500/30 blur-[60px] rounded-full opacity-70 -z-10" data-id="element-164"></div>
                <div className="absolute inset-0 bg-rose-400/15 blur-[100px] rounded-full scale-150 -z-10" data-id="element-165"></div>

                <motion.img animate={floatingAnimation} src="https://cdn.magicpatterns.com/uploads/sYyS7fZZuqSQHhWTrXs5fS/b4894e72-7948-44f3-a25e-b90ddd4b76f6.png" alt="Checklist Método Orgánico" className="h-64 sm:h-72 object-contain drop-shadow-[0_20px_40px_rgba(236,72,153,0.4)]" data-id="element-166" />
              </div>

              <div className="inline-block px-4 py-1.5 rounded-full bg-pink-500/20 text-pink-300 font-bold mb-4 w-max text-lg" data-id="element-167">
                BONUS 3
              </div>
              <h4 className="text-xl sm:text-2xl font-bold text-white mb-3" data-id="element-168">
                Checklist Método Orgánico
              </h4>
              <div className="flex-grow" data-id="element-169">
                <p className="text-slate-400 leading-relaxed" data-id="element-170">
                  Un paso a paso simple para ayudarte a organizar tus acciones,
                  crear presencia digital y comenzar a compartir tus ideas con
                  el mundo.
                </p>
              </div>

              {/* Value emphasis */}
              <div className="mt-6 pt-4 border-t border-white/10 flex items-center justify-between" data-id="element-171">
                <span className="text-slate-500 line-through text-lg" data-id="element-172">
                  Valor: US$17
                </span>
                <span className="text-emerald-400 font-extrabold text-xl tracking-wide" data-id="element-173">
                  ¡GRATIS!
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}